import Vue from 'vue';
import VueRouter from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import App from './App.vue';
import Track from './pages/TrackTrace.vue';
import NotFound from './pages/NotFound.vue';
import 'moment/locale/nl';

Vue.config.productionTip = false;
Vue.use(VueRouter);

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

moment.locale('nl');

const routes = [
  {
    path: '/tr/:token',
    component: Track,
  },

  {
    path: '*',
    component: NotFound,
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

new Vue({
  render: (h) => h(App),
  router,
}).$mount('#app');
